import axios from 'axios'
import Config from '../Config/Config'

export default axios.create({
    baseURL: Config.apiBaseUrl.toString(),
})
